import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';

const ExpenseChart = ({ data, xAxisKey, barDataKey, dataKeyLabel, onBarClick }) => {
    return (
        <div style={{ width: '100%', height: 400 }}>
            <ResponsiveContainer>
                <BarChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 50,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis 
                        dataKey={xAxisKey} 
                        angle={-45} 
                        textAnchor="end" 
                        height={80} 
                        tick={{ fontSize: 12 }} 
                    />
                    <YAxis 
                        tickFormatter={(value) => `Rs ${value}`} 
                        tick={{ fontSize: 12 }}
                    />
                    <Tooltip 
                        formatter={(value) => [`Rs ${value}`, dataKeyLabel]}
                        labelStyle={{ color: '#333', fontWeight: 'bold' }}
                    />
                    <Bar 
                        dataKey={barDataKey} 
                        fill="#1c88bf" 
                        radius={[4, 4, 0, 0]} 
                        style={{ cursor: 'pointer' }}
                        onClick={(data) => { if (onBarClick) onBarClick(data.payload || data) }} 
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ExpenseChart;
